module.exports = __webpack_public_path__ + "img/zixunxinxi.56b01ed5.png";